export default {"src":"/_next/static/media/BonusCard.ed18fe1f.svg","height":12,"width":80};